export default __webpack_public_path__ + "static/media/IKEA-family-credit-card.4735e414.svg";